// extracted by mini-css-extract-plugin
export default {"page":"KC","wrapper":"LC","text":"MC","icons":"NC","icon":"OC","icon_text":"PC","carousel_wrapper":"QC","slide":"RC","image":"SC","arrows":"TC","prev":"UC","modal_root":"VC","x_mark":"WC","modal":"XC","images":"YC","main_image":"ZC","name":"aE"};
    if(module.hot) {
      // 1711394578597
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  